import styled from "@emotion/styled";
import {
  BrushWrapper,
  Container,
  CtaBox,
  H2,
  IconCloudDownload,
  IconCrown,
  IconEye,
  Stack,
  Text,
} from "atoms";
import { constants } from "config";

function OpenCallsFooter() {
  return (
    <SBrushWrapper bg="accent2" brush="1">
      <Container width="lg">
        <Stack gap="md">
          <Container width="xs">
            <H2 textAlign="center">More from Hug&nbsp;Studios</H2>
            <Text textAlign="center">
              From learning at your own pace to getting support where you need
              it most, HUG offers accessible resources to take you further on
              your artistic&nbsp;journey.
            </Text>
          </Container>
          <Grid>
            <SCtaBox
              title="Free Resources"
              text="Benefit from downloadable free resources, from comprehensive artist and art collector guides to interactive tools and worksheets."
              linkText="Explore Available Resources"
              linkUrl="/resources"
              icon={<IconCloudDownload color="fg80" accent="accent4" />}
            />

            <SCtaBox
              title="Financial Support"
              text="We buy art weekly from lucky HUG Artists, and also offer two $500 USD grants to emerging artists each month as part of our HUG Visionaries program."
              linkText="Apply to be a Hug Visionary"
              linkUrl="/open-calls/hug-visionaries"
              icon={<IconEye color="fg80" accent="accent1" />}
            />

            <SCtaBox
              title="Creator Royalties"
              text="Your weekly source of education, opportunities, and news for creatives on the latest in arts and technology alongside lively conversations with Randi Zuckerberg."
              linkText="Read the latest"
              linkUrl={constants.creatorRoyaltiesURL}
              linkTarget="_blank"
              icon={<IconCrown color="fg80" accent="accent3" />}
            />
          </Grid>
        </Stack>
      </Container>
    </SBrushWrapper>
  );
}

const SBrushWrapper = styled(BrushWrapper)({
  padding: "4rem 0",
});

const Grid = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.gap,
  [theme.breakpoints.desktopMedium]: {
    flexDirection: "row",
  },
}));

const SCtaBox = styled(CtaBox)(({ theme }) => ({
  display: "flex",
  "&&": { color: theme.colors.fg },
  "&>div": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    "&>div": {
      flex: "auto",
      gap: "2rem",
    },
  },
  h3: { fontSize: theme.fontSizes.md },
}));

export { OpenCallsFooter };
